<template>
  <v-app class="change-it">
    <Toggler @close="statechange" />
    <transition name="bounce">
      <Aside v-show="showaside" />
    </transition>
    <Firstslide :firstslide="firstheight" />
    <Secondslide :firstslide="secondheight" />
    <Scrollup v-show="scrolltotopornot" />
    <Thirdslide :thirdslide="thirdheight" />
    <Fourthslide :fourthslide="fourthheight" />
    <Fifthslide :fifthslide="fifthheight" />
    <Sixthslide :sixthslide="sixthheight" />
    <Seventhslide :seventhslide="seventhheight" />
  </v-app>
</template>

<script>
import Aside from "./components/Aside.vue";
import Fifthslide from "./components/Fifthslide.vue";
import Firstslide from "./components/Firstslide.vue";
import Fourthslide from "./components/Fourthslide.vue";
import Scrollup from "./components/scrolltotop.vue";
import Secondslide from "./components/Secondslide.vue";
import Seventhslide from "./components/Seventhslide.vue";
import Sixthslide from "./components/Sixthslide.vue";
import Thirdslide from "./components/thirdslide.vue";
import Toggler from "./components/Toggler.vue";
export default {
  name: "App",

  components: {
    Aside,
    Firstslide,
    Secondslide,
    Scrollup,
    Toggler,
    Thirdslide,
    Fourthslide,
    Fifthslide,
    Sixthslide,
    Seventhslide,
  },

  data: () => ({
    showaside: true,
    scrolltotopornot: true,
    firstheight: 0,
    secondheight: 0,
    seventhheight: 0,
    sixthheight: 0,
    fifthheight: 0,
    fourthheight: 0,
    thirdheight: 0,
  }),
  methods: {
    statechange(val) {
      this.showaside = val;
    },
  },
};
</script>
<style>
@-moz-document url-prefix() {
  /* Disable scrollbar Firefox */
  html {
    scrollbar-width: none;
    scroll-behavior: smooth;
  }
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  .change-it {
    max-height: 60vh;
  }
}
* {
  scroll-behavior: smooth;
}
@media screen and (max-height: 2000px) and (min-height: 1300px) and (min-width: 1000px) {
  .change-it {
    max-height: 60vh;
  }
}
::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar-button {
  display: none;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
body {
  -ms-overflow-style: none;
}
</style>
